<template>
	<div :class="customClass">
		<template v-for="flag in flags">
			<img :src="flag.image" :alt="flag.title"/>
		</template>
	</div>
</template>
<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
	name: "AdvertFlagComponent",
	props: {
		flags: {
			type: Array,
			default: [],
			required: true
		},
		customClass: {
			type: String,
			default: '',
			required: false,
		},
	}
})
</script>
<style scoped>

</style>
